import React from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

const AppDialog = ({
  children,
  title,
  handleClose = () => {},
  open = false,
  dialogProps = {},
  dialogFooterElement,
}) => {
  return ReactDOM.createPortal(
    <Dialog {...dialogProps} open={open} onClose={handleClose}>
      <DialogTitle sx={{ fontSize: 16 }}>{title}</DialogTitle>
      <DialogContent>{children}</DialogContent>
      {dialogFooterElement ?? ''}
    </Dialog>,
    document.body,
  );
};

export default React.memo(AppDialog);

AppDialog.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node,
  handleClose: PropTypes.func,
  open: PropTypes.bool,
  dialogProps: PropTypes.object,
  dialogFooterElement: PropTypes.node,
};
